import { useContext } from 'react';
import type { ExchangeServiceApi } from '@pa-api/pa-logic-exc-gate';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useExcGateApiClient(): ExchangeServiceApi {
  const { excGateApi } = useContext(ApiContext);

  return excGateApi;
}
